"use strict";
import 'bootstrap/js/src/collapse';

// This function is shared between default exported function and setupHeaderAvatarMenu exported function
// so they can be called from other JS files, notably realTimeMessaging/index
function setupAvatarMenu() {
    $("#avatarNotification").click(function () {
        if ($("#pills-notification-tab").hasClass("active")) {
            sendNotificationsViewed($("#notificationMenu").find(".allNotifications"));
        }
    });
}

export default (function () {

    global.setupHeaderAvatarMenu = setupAvatarMenu;

    setupAvatarMenu();

    // Sidebar menu js
    let menuItems = document.querySelectorAll("button.menu-sidebar-accordion__header");
    let menuItemContent = document.querySelectorAll(".menu-sidebar-accordion__content");
    let plusButton = document.querySelector('.jsExpandMenu');
    let expandedMenuSidebar = document.querySelector(".menu-sidebar-nav");

    // Open/close sidebar menu when clicks on plus footer button
    if (plusButton) {
        plusButton.addEventListener("click", e => {
            expandedMenuSidebar.classList.toggle("menu-sidebar-nav--opened");
            if (expandedMenuSidebar.classList.contains("menu-sidebar-nav--opened")) {
                let menuItemActive = document.querySelector(".menu-sidebar-accordion__header--collapsed-active");

                if (menuItemActive.classList.contains("collapsed")) {
                    menuItemActive.classList.remove("collapsed");
                    menuItemActive.parentNode.querySelector(".menu-sidebar-accordion__content").classList.add("show");
                }
            } else {
                closeSidebarMenu();
            }
        });
    }

    // Open sidebar menu when clicks on accordion item
    for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener("click", event => {
            expandedMenuSidebar.classList.add("menu-sidebar-nav--opened");
        });
    }

    // Check if clicks outside sidebar menu
    document.addEventListener("click", event => {
        if (expandedMenuSidebar) {
            let isClickInside = expandedMenuSidebar.contains(event.target);
            if (!isClickInside) {
                closeSidebarMenu();
            }
        }
    });

    // Close sidebar menu and collapse all accordion item
    function closeSidebarMenu() {
        expandedMenuSidebar.classList.remove("menu-sidebar-nav--opened");
        for (let i = 0; i < menuItems.length; i++) {
            if (menuItems[i].classList.contains("collapsed") != null) {
                menuItems[i].classList.add("collapsed");
            }
            if (menuItemContent[i].classList.contains("show") != null) {
                menuItemContent[i].classList.remove("show");
            }
        }
    }

}());

export function setupHeaderAvatarMenu() {
    setupAvatarMenu();
}